export default "__VITE_ASSET__3BEfBEOx__"